import React from 'react'
import gump from "../images/gump.jpg"
import SmartStock from "../images/SmartStock.png"
import SentimentAnalysis from "../images/sentiment-analysis.jpg"
import react from "../images/logo192.png"
import { FaGithub, FaReddit } from "react-icons/fa";
import firebase from "../images/firebase-logo.png"
import dialogflow from "../images/dialogflow-logo.png"
import cloudfunction from "../images/cloud-functions-logo.png"
import zero from "../images/zero-logo.png"
import python from "../images/python_logo.png"
import flask from "../images/flask_logo.png"
import sql from "../images/sql_logo.png"
import typescript from "../images/typescript_logo.png"
import nextjs from "../images/nextjs_logo.png"
import java from "../images/java_logo2.png"
import tailwind from "../images/tailwind_logo.png"
import cloudfront from "../images/cloudfront.jpg"
import s3 from "../images/s3.png"
import traffic from "../images/traffic.jpg"
import tf from "../images/tf.png"
import logo from "../images/logo.jpg"
import logo1 from "../images/logo1.png"
import swift from "../images/swift_logo.png"
import swiftui from "../images/swiftui_logo.png"
import scrumpad from "../images/scrumpad.jpg"
import opencv from "../images/opencv.png"
import mp from "../images/mediapipe.png"
import aws from "../images/aws.png"
import textsight from "../images/textsight.png"
import vertex from "../images/vertex.png"
import clausepause from "../images/clausepause.png"
import rogue from "../images/rogue.png"
import hoverpeek from "../images/hoverpeek.png"
import inquira from "../images/inquira.png"
import javascript from "../images/js_logo.png"

function Projects() {
    return (
        <div className='min-h-screen w-full bg-gradient-to-b from-zinc-400 to-slate-300 py-24'>
            <div className='max-w-6xl mx-auto px-4 sm:px-6 lg:px-8'>
                <div className='text-center mb-16'>
                    <h2 className='text-4xl md:text-6xl font-bold text-black'>
                        Projects
                    </h2>
                </div>
                
                <div className='grid grid-cols-1 lg:grid-cols-2 gap-8'>
                    {projects.map((project, index) => (
                        <div key={index} className='bg-gradient-to-b from-gray-900 to-slate-800 rounded-xl shadow-xl overflow-hidden transform hover:scale-[1.02] transition-transform duration-300'>
                            <div className='flex flex-col md:flex-row h-64'>
                                <div className='md:w-2/5 p-4 flex items-center justify-center'>
                                    <div className='w-full h-48 relative'>
                                        <img 
                                            className='absolute inset-0 w-full h-full object-cover rounded-lg' 
                                            src={project.image} 
                                            alt={project.title} 
                                        />
                                    </div>
                                </div>
                                <div className='md:w-3/5 p-6 flex flex-col justify-between'>
                                    <div>
                                        <h3 className='text-2xl font-bold text-white mb-2'>{project.title}</h3>
                                        <p className='text-gray-200 text-sm md:text-base'>{project.description}</p>
                                    </div>
                                    <div className='flex flex-wrap gap-3 mt-4'>
                                        {project.github && (
                                            <a 
                                                href={project.github}
                                                className='text-white hover:text-gray-400 transition-colors duration-200'
                                                target="_blank"
                                                rel="noreferrer"
                                                aria-label="GitHub repository"
                                            >
                                                <FaGithub size={32} />
                                            </a>
                                        )}
                                        {project.reddit && (
                                            <a 
                                                href={project.reddit}
                                                className='text-[#FF4500] hover:text-orange-400 transition-colors duration-200'
                                                target="_blank"
                                                rel="noreferrer"
                                                aria-label="Reddit"
                                            >
                                                <FaReddit size={32} />
                                            </a>
                                        )}
                                        {project.tech.map((tech, techIndex) => (
                                            <img 
                                                key={techIndex}
                                                src={tech.icon} 
                                                alt={tech.name} 
                                                className='h-8 w-8 object-contain hover:scale-110 transition-transform duration-200' 
                                            />
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

const projects = [
    {
        title: 'Rogue',
        description: 'A detective game for Reddit where you investigate posts to find the rogue infiltrator from another subreddit.',
        image: rogue,
        reddit: 'https://www.reddit.com/r/ogue/',
        tech: [
            { name: 'React', icon: react },
            { name: 'Next.js', icon: nextjs },
            { name: 'TypeScript', icon: typescript }
        ]
    },
    {
        title: 'HoverPeek',
        description: "Know what's behind every link. HoverPeek delivers AI-powered summaries, security analysis, and intelligent previews.",
        image: hoverpeek,
        github: 'https://github.com/AdityaBoddepalli/HoverPeek',
        tech: [
            { name: 'React', icon: react },
            { name: 'TypeScript', icon: typescript }
        ]
    },
    {
        title: 'Inquira',
        description: 'Gather, summarize, and organize online research just by highlighting',
        image: inquira,
        github: 'https://github.com/AdityaBoddepalli/Inquira',
        tech: [
            { name: 'React', icon: react },
            { name: 'JavaScript', icon: javascript }
        ]
    },
    {
        title: 'ClausePause',
        description: "A web extension summarizing T&C and privacy policies.",
        image: clausepause,
        github: 'https://github.com/AdityaBoddepalli/ClausePause',
        tech: [
            { name: 'React', icon: react },
            {name: 'Vertex', icon: vertex}


        ]

    },
    {
        title: 'TextSight',
        description: 'An NLP tool to translate and summarize text deployed serverless on AWS.',
        image: textsight,
        github: 'https://github.com/AdityaBoddepalli/TextSight',
        tech: [
            { name: 'Python', icon: python },
            { name: 'AWS', icon: aws },

        ]

    },
    {
        title: 'FormFusion',
        description: 'A web application for analyzing workout routines through video processing using OpenCV and MediaPipe.',
        image: logo1,
        github: 'https://github.com/AdityaBoddepalli/FormFusion',
        tech: [
            { name: 'Python', icon: python },
            { name: 'OpenCV', icon: opencv },
            { name: 'MediaPipe', icon: mp }
        ]
    },
    {
        title: 'Zero',
        description: 'An AI-powered chatbot that answers questions about my resume using Dialogflow and GPT.',
        image: zero,
        github: 'https://github.com/AdityaBoddepalli/Zero-chatbot',
        tech: [
            { name: 'Firebase', icon: firebase },
            { name: 'Dialogflow', icon: dialogflow },
            { name: 'Cloud Functions', icon: cloudfunction }
        ]
    },
    {
        title: 'Sentiment Analysis',
        description: 'A Next.js application that analyzes sentiments and emotions in text or URLs.',
        image: SentimentAnalysis,
        github: 'https://github.com/AdityaBoddepalli/Sentiment-Analysis',
        tech: [
            { name: 'TypeScript', icon: typescript },
            { name: 'Next.js', icon: nextjs }
        ]
    },
    {
        title: 'Smart Stock',
        description: 'A Flask-based stock trading and portfolio management application with MySQL backend.',
        image: SmartStock,
        github: 'https://github.com/AdityaBoddepalli/SmartStock',
        tech: [
            { name: 'Python', icon: python },
            { name: 'Flask', icon: flask },
            { name: 'SQL', icon: sql }
        ]
    },
    {
        title: 'Scrumpad',
        description: 'An iOS app built with SwiftUI for managing and transcribing daily scrum meetings.',
        image: scrumpad,
        github: 'https://github.com/AdityaBoddepalli/Scrumdinger',
        tech: [
            { name: 'Swift', icon: swift },
            { name: 'SwiftUI', icon: swiftui }
        ]
    },
    {
        title: 'Image Processor',
        description: 'A Java-based GUI application for applying various image processing effects.',
        image: gump,
        github: 'https://github.com/AdityaBoddepalli/Image-Processor',
        tech: [
            { name: 'Java', icon: java }
        ]
    },
    {
        title: 'This Website',
        description: 'A React portfolio website using TailwindCSS and deployed on AWS CloudFront.',
        image: logo,
        github: 'https://github.com/AdityaBoddepalli/portfolio',
        tech: [
            { name: 'React', icon: react },
            { name: 'Tailwind', icon: tailwind },
            { name: 'CloudFront', icon: cloudfront },
            { name: 'S3', icon: s3 }
        ]
    },
    {
        title: 'Traffic-sign-AI',
        description: 'A TensorFlow neural network achieving 96% accuracy in traffic sign classification.',
        image: traffic,
        github: 'https://github.com/AdityaBoddepalli/Traffic-sign-AI',
        tech: [
            { name: 'Python', icon: python },
            { name: 'TensorFlow', icon: tf }
        ]
    }
];

export default Projects